/* Runway — PLP facets: submit the filter form on any change.
   Server-side filtering (Search & Discovery / collection.filters) keeps
   URLs shareable and pagination/SEO correct at this catalog size. */
(function () {
  'use strict';
  const form = document.querySelector('[data-facets-form]');
  if (!form) return;

  let priceTimer = null;
  function submit() {
    // drop empty inputs so URLs stay clean
    form.querySelectorAll('input[type="number"]').forEach((i) => {
      i.disabled = i.value === '';
    });
    form.submit();
  }

  form.addEventListener('change', (e) => {
    if (e.target.type === 'number') {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(submit, 600);
      return;
    }
    submit();
  });

  const sort = document.getElementById('SortSelect');
  if (sort) sort.addEventListener('change', submit);
})();
